<template>
  <div>
   <audit-flow-manage />
  </div>
 </template>

<script>
import auditFlowManage from '../auditFlowManage'

export default {
  components: {
    auditFlowManage,
  },
}
</script>

 <style scoped lang='scss'>

 </style>

